/**
 * TRAD-3653 — 부팅 때 prerender 가 굳힌 페이지 단위 head 태그(data-prerendered)만 지운다.
 *
 * prerender 산출물 head(정적 한 벌) + 런타임 PageMeta(React 19 hoisting, 한 벌) = 두 벌이던 것을 런타임 한 벌로.
 * JS 를 안 돌리는 크롤러는 지금처럼 정적 한 벌을 보고, 브라우저·JS 렌더 크롤러는 런타임 한 벌만 본다.
 * 🔴 표지 없는 태그(폴백 셸의 noindex · 사이트 공통 og:site_name 등)는 남는다 — 표지는 prerender 의 페이지별 저장에서만 붙는다
 *    (scripts/lib/prerender-head.mjs `markPrerenderedHead`, 속성 이름 PRERENDER_MARK 와 같아야 한다 — 테스트로 고정).
 * 반드시 React 렌더 «전에» 부른다(src/main.tsx). 렌더 뒤에 부르면 표지가 없는 런타임 태그만 남아 결과는 같지만, 그 사이 두 벌이 보인다.
 */
export const PRERENDERED_HEAD_ATTR = 'data-prerendered';

export const removePrerenderedHead = (doc: Document = document): number => {
  const nodes = Array.from(doc.head.querySelectorAll(`[${PRERENDERED_HEAD_ATTR}]`));
  nodes.forEach(node => node.remove());
  return nodes.length;
};
